import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Props<T> = {
  inventoryId: string;
  body: T;
  qty: number;
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const addAtomsToInventory = async <T>({
  inventoryId,
  qty,
  body,
  onUnauthorized,
  onProgress,
}: Props<T>) => {
  const token = getCookie('auth_token');

  const iterations = Math.ceil(qty / 1000);
  const results: Response<T>[] = [];

  let finishedRequests = 0;

  for (let i = 0; i < iterations; i++) {
    const requestQty = Math.min(1000, qty - i * 1000);

    const response = await fetcher<Response<T>>({
      url: `/inventory/${inventoryId}/add/`,
      method: 'PUT',
      token,
      body: { ...body, qty: requestQty },
      onUnauthorized,
    })
      .then((response) => {
        finishedRequests++;

        if (onProgress) {
          onProgress((finishedRequests / iterations) * 100);
        }

        return response;
      })
      .catch((error) => {
        console.error(
          'Error occurred in function "addAtomsToInventory" in file "src/shared/api/inventory/addAtomsToInventory.ts":',
          error,
        );

        return {
          ...(error as Response<T>),
          data: { ...body },
        } as Response<T>;
      });

    results.push(response);
  }

  return results;
};

export default addAtomsToInventory;
